import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {Typography, ListItem, makeStyles} from '@material-ui/core';
import {AnchorLink} from 'gatsby-plugin-anchor-links';

const useStyles = makeStyles(theme => ({
  item: {
    display: 'flex',
    textTransform: 'none',
    width: '100%',
    color: theme.palette.text.primary,
    '&:hover': {
      background: 'transparent',
      color: theme.palette.primary.main,
    },
  },
  itemHidden: {
    display: 'none',
  },
  itemActive: {
    color: theme.palette.primary.main,
    '& span': {
      fontWeight: 700,
    },
  },
}));

const NavItem = ({className, href, title, expanded, ...rest}) => {
  const classes = useStyles();

  return (
    <ListItem
      className={clsx(classes.item, expanded ? '' : classes.itemHidden, className)}
      {...rest}
    >
      <Typography variant="body2" component="span">
        <AnchorLink to={href} className={classes.item}>
          {title}
        </AnchorLink>
      </Typography>
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
  expanded: PropTypes.bool,
};

export default NavItem;
